export enum BoxHeaderName {
    LEFT_BOX = "LEFT_BOX",
    RIGHT_BOX = "RIGHT_BOX",
    PARENT = "PARENT",
}
